<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>
        <d-col md="12">
          <d-card>
            <d-tabs card ref="tabs">
              <d-tab title="Cadastro de Opções" active class="p-3">
                <quotation-types-form/>
              </d-tab>
              <d-tab title="Pagamento" class="p-3">
                <d-row>
                  <d-col md="6" class="form-group">
                    <quotation-type-installments-form/>
                  </d-col>
                  <d-col md="6" class="form-group">
                    <payment-info-form/>
                  </d-col>
                </d-row>
              </d-tab>
              <d-tab title="Obrigações do contrato" class="p-3">
                <obligations-form/>
              </d-tab>
              <d-tab title="Itens Inclusos" class="p-3">
                <items-included-form/>
              </d-tab>
              <d-tab title="Segmentos" class="p-3">
                <drives-form/>
              </d-tab>
              <d-tab title="Apresentação" class="p-3" v-if="isAdmin">
                <presentation-form/>
              </d-tab>
              <d-tab title="Classes" class="p-3" v-if="isAdmin">
                <classes-form/>
              </d-tab>
            </d-tabs>
          </d-card>
        </d-col>
      </d-row>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import ClassesForm from '_modules/settings/components/ClassesForm.vue';
import DrivesForm from '_modules/settings/components/DrivesForm.vue';
import ObligationsForm from '_modules/settings/components/ObligationsForm.vue';
import ItemsIncludedForm from '_modules/settings/components/ItemsIncludedForm.vue';
import PresentationForm from '_modules/settings/components/PresentationForm.vue';
import QuotationTypesForm from '_modules/settings/components/QuotationTypesForm.vue';
import QuotationTypeInstallmentsForm from '_modules/settings/components/QuotationTypeInstallmentsForm.vue';
import PaymentInfoForm from '_modules/settings/components/PaymentInfoForm.vue';

export default {
  name: 'quotation-settings-form',
  components: {
    ClassesForm,
    DrivesForm,
    ObligationsForm,
    ItemsIncludedForm,
    PresentationForm,
    QuotationTypesForm,
    QuotationTypeInstallmentsForm,
    PaymentInfoForm,
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'checkAdmin',
    ]),
  },
  mounted() {
    this.checkAdmin()
      .then(() => this.$refs.tabs && this.$refs.tabs.updateTabs());
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  .card-header { background: rgba(0, 0, 0, 0.03); }
}
</style>
